import Button from 'react-bootstrap/Button';
import { DOCUMENT_FORMAT, MIME_TYPES } from '../../constants';
import { dataURLtoByteArray, downloadFile, getMsDocIcon } from '../../utils/utils';
import styles from './FileViewer.module.scss';

const FileViewer = ({ file, fileName, type }) => {
    const Icon = getMsDocIcon(type);
    const fileType = MIME_TYPES[DOCUMENT_FORMAT[type]];
    const data = dataURLtoByteArray(file);

    return (
        <div className={`bg-white w-100 rounded p-3 d-flex flex-column justify-content-center align-items-center ${styles.wrapper}`}>
            <div className="bg-light rounded p-2 px-3 mb-3">
                <Icon className="me-2" />
                {fileName}
            </div>
            <Button
                onClick={() => downloadFile(
                    {data, fileName, fileType}
                )}>
                Download
            </Button>
        </div>
    )
}

export default FileViewer;
